import { render } from "./QuizResults.vue?vue&type=template&id=0456307c"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"

import "./QuizResults.vue?vue&type=style&index=0&id=0456307c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__